import axios from "axios";

const LogOutOK = () => {
  axios.get("/auth/logout");
  //WebPack Build 시 주석 풀어 줘야함.
  //      axios.get('auth/logout', {headers: {
  //       "Access-Control-Allow-Origin": "*",
  //       "Access-Control-Allow-Methods": "*",
  //       "content-type": "application/json",
  //       "Access-Control-Allow-Credentials":true,
  //       "Access-token" : window.sessionStorage.getItem('token'),
  //       "Authorization" : `Bearer ${window.sessionStorage.getItem('token')}`,
  //     }})
  //     .then((response) => {
  //        console.log(response.headers);
  //        window.sessionStorage.clear();
  //       //  window.location.replace("/");
  //     }).catch((Error)=> {
  //        console.log(`[ERROR] ${Error}`);
  //        alert(`로그인 아웃 할 수 없습니다.${Error}`);
  //       //  window.location.replace("/");
  //     })

  window.sessionStorage.clear();
  window.location.replace("/");
};
export default LogOutOK;
